import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';

const bg = '#f0ebe3';
const red = '#6B1A1A';
const dark = '#4a1010';
const serif = 'Playfair Display, serif';
const body = 'Cormorant Garamond, serif';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setStatus('ready');
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleReset = async () => {
    if (!password || !confirm) {
      setStatus('Please fill in both fields.');
      return;
    }
    if (password !== confirm) {
      setStatus('Passwords do not match.');
      return;
    }
    if (password.length < 6) {
      setStatus('Password must be at least 6 characters.');
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setStatus(error.message);
    } else {
      setStatus('Password updated successfully! Redirecting...');
      setTimeout(() => navigate('/dashboard'), 2000);
    }
    setLoading(false);
  };

  const inputStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '0.5px solid #d4c9bc',
    padding: '12px 0',
    fontSize: '15px',
    fontFamily: body,
    color: '#2a1a1a',
    outline: 'none',
    width: '100%'
  };

  return (
    <div style={{ backgroundColor: bg, minHeight: '100vh', fontFamily: body, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: '420px', padding: '60px 40px', border: '1px solid #d4c9bc' }}>
        <p style={{ color: red, fontSize: '11px', letterSpacing: '4px', margin: '0 0 16px', textAlign: 'center' }}>CLIENT PORTAL</p>
        <h2 style={{ fontFamily: serif, fontSize: '36px', fontWeight: '700', color: dark, margin: '0 0 8px', textAlign: 'center', lineHeight: '1' }}>Set Password</h2>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', margin: '20px 0 40px' }}>
          <div style={{ height: '1px', width: '60px', backgroundColor: '#c9a882' }}></div>
          <div style={{ width: '6px', height: '6px', backgroundColor: '#c9a882', transform: 'rotate(45deg)' }}></div>
          <div style={{ height: '1px', width: '60px', backgroundColor: '#c9a882' }}></div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <input
            placeholder="New Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
          <input
            placeholder="Confirm Password"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            style={inputStyle}
          />
          {status && status !== 'ready' && (
            <p style={{ color: status.includes('success') ? 'green' : red, fontSize: '13px', margin: 0 }}>{status}</p>
          )}
          <button
            onClick={handleReset}
            style={{ backgroundColor: red, color: bg, padding: '18px', fontSize: '11px', letterSpacing: '3px', border: 'none', cursor: 'pointer', fontFamily: body, marginTop: '8px' }}
          >
            {loading ? 'UPDATING...' : 'SET PASSWORD'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;